import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "zakat-donation-form-style-6" }
const _hoisted_2 = { class: "zakat-amount-display" }
const _hoisted_3 = { class: "amount-container" }
const _hoisted_4 = { class: "currency-symbol" }
const _hoisted_5 = { class: "amount-value" }
const _hoisted_6 = {
  key: 0,
  class: "currency-section"
}
const _hoisted_7 = { class: "el-custom-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Amount Display "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.getSymbol()), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.formatAmount($setup.store.amount)), 1 /* TEXT */)
      ])
    ]),
    _createCommentVNode(" Currency Selection (if needed) "),
    ($props.show_currency_dropdown && $props.currencies && Object.keys($props.currencies).length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("label", { class: "field-label" }, "Currency", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              class: "w-100",
              modelValue: $setup.store.currency,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.currency) = $event)),
              onChange: $setup.onCurrencyChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.currencies, (curr, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: key,
                    key: key,
                    label: curr
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}